export default "__VITE_ASSET__hXKs672Y__"